// packages/agent-kit/src/useAgentSettings.ts
import useSWR from 'swr';
import { agentService, isApiError } from '@dopomogai/api-client';
import type { UUID, AgentSettings } from '@dopomogai/types';
import { AgentKitError } from '../types';

export const useAgentSettings = (agentId: UUID | null) => {
  const key = agentId ? ['agent-settings', agentId] : null;
  
  const { data, error, isLoading, mutate } = useSWR<AgentSettings, AgentKitError>(
    key,
    async (args: readonly [string, UUID]) => {
      const [, id] = args;
      const res = await agentService.getAgentSettings(id);
      if (isApiError(res)) throw new AgentKitError(res.message, res);
      // Cast the response to AgentSettings to ensure type safety in UI
      return res as AgentSettings;
    },
  );

  const update = async (settings: AgentSettings) => {
    if (!agentId) throw new AgentKitError('Missing agent id.');
    const res = await agentService.updateAgentSettings(agentId, settings);
    if (isApiError(res)) throw new AgentKitError(res.message, res);
    mutate();
    return res as AgentSettings;
  };

  // Ensure we always return an object, even if data is undefined initially
  return { 
    settings: data || {}, 
    isLoading, 
    error, 
    update, 
    mutate 
  };
};